import { createAction } from 'redux-actions';

export const siteLoad = createAction('SITE_LOAD');
export const siteLoaded = createAction('SITE_LOADED');
